



























import { Pracovnik } from '@/modules/administrace/pracovnik';

import Base from './Base.vue';
import { RozsahDate } from '../constants';
import { mutations } from '../store/types';

export default Base.extend({
	name: 'OdpisPP',
	components: {
		BaseFilterSestav: Base,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		pracovnikFilter() {
			return {
				ProvozovnaId: this.ProvozovnaId,
				PracovnikOzn: this.PracovnikOzn,
			};
		},
	},
	created() {
		this.RozsahDate = RozsahDate.casMinulyMesic;
	},
	methods: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${mutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
